export default __webpack_public_path__ + "static/media/12.b3ef96ee.png";